import api from 'services/api';
import Axios from 'axios';

export const getTicketsService = async (
  params,
  ctrl = new AbortController(),
) => {
  try {
    return await api.get('/v3/ticket/', { params, signal: ctrl.signal });
  } catch (e) {
    throw e;
  }
};

export const getMessagesService = async params => {
  try {
    return await api.get('/v3/message/', { params });
  } catch (e) {
    throw e;
  }
};

export const getTicketService = async (id, params?) => {
  try {
    return await api.get(`/v3/ticket/${id}/`, { params });
  } catch (e) {
    throw e;
  }
};

export const updateTicketService = async (id, data) => {
  try {
    return await api.patch(`/v3/ticket/${id}/`, data);
  } catch (e) {
    throw e;
  }
};

export const createTicketService = async payload => {
  try {
    return await api.post('/v3/ticket/', payload);
  } catch (e) {
    throw e;
  }
};

export const createTicketMessageService = async payload => {
  try {
    return await api.post('/v3/message/', payload);
  } catch (e) {
    throw e;
  }
};

export const getTicketIssuesService = async (params?) => {
  try {
    return await api.get('/v3/ticket-issue/', { params });
  } catch (e) {
    throw e;
  }
};

export const getTicketRatingService = async (authenticated, hash) => {
  const apiUrl =
    window.location.hostname === 'demo.cloudez.io'
      ? 'https://dev-api.cloudez.io/'
      : process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL
      : 'https://api.cloudez.io/';
  try {
    return authenticated
      ? await api.get(`/v3/ticket-rating/${hash}/`)
      : await Axios.get(`${apiUrl}v3/ticket-rating/${hash}/`);
  } catch (e) {
    throw e;
  }
};

export const updateTicketRatingService = async (
  authenticated,
  hash,
  rating,
) => {
  const apiUrl =
    window.location.hostname === 'demo.cloudez.io'
      ? 'https://dev-api.cloudez.io/'
      : process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL
      : 'https://api.cloudez.io/';
  try {
    return authenticated
      ? await api.patch(`/v3/ticket-rating/${hash}/`, rating)
      : await Axios.patch(`${apiUrl}v3/ticket-rating/${hash}/`, rating);
  } catch (e) {
    throw e;
  }
};

export const pickupTicketService = async id => {
  try {
    return await api.post(`/v3/ticket/${id}/pickup/`);
  } catch (e) {
    throw e;
  }
};

export const changeResponsibleService = async (id, responsible) => {
  try {
    return await api.patch(`/v3/ticket/${id}/change_responsible/`, {
      responsible,
    });
  } catch (e) {
    throw e;
  }
};
